/// <reference path="../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import Texts = Models.SupportToolkitTexts;
    import INetworkNode = Application.Models.INetworkNode;

    export interface IRouteSupportParams {
        nodeId: string;
        backUrl: string;
    }

    /**
     * NodeSupportController class
     */
    export class NodeSupportController {
        public static $name: string = "nodeSupportController";
        public static $inject: string[] = ['$scope',
                                           '$q',
                                           'ModalService',
                                           '$timeout',
                                           '$interval',
                                           '$routeParams',
                                           'deviceGuiService',
                                           '$sce',
                                           'networkElementService',
                                           'networkNodeService',
                                           'gatewayService',
                                           'timezoneService',
                                           '$location',
                                           'blockService',
                                           'managementService',
                                           'probeService',
                                           'mvpAppScannerJobService',
                                           'mvpServerInfoService',
                                           'clipboard',
                                           'messageTranslationsService',
                                           'blockConnectionNodesService',
                                           ];

        public startDate: Date;
        public googlePingResult: Models.ITestResult;
        public flexoPingResult: Models.ITestResult;
        public googleTracerouteResult: Models.ITestResult;
        public flexoTracerouteResult: Models.ITestResult;
        public udpPingResult: Models.ITestResult;
        public udpListenResult: Models.ITestResult;
        public mappingToFlexo: Models.MappingInfo;
        public mappingFromFlexo: Models.MappingInfo;
        public node: Models.NetworkNode;
        public targetSrt: Models.NetworkNode;
        public targetPort: number = 45000;
        public isClient: boolean;
        public isServer: boolean;
        public isServerTS: boolean;
        public isIO: boolean;
        public serverClients: Models.ServerClientsInfo;
        public backUrl: string = "network-nodes";
        public pingGoogleIp: string = "8.8.8.8";
        public tracerouteGoogleIp: string = "8.8.8.8";
        public speedTestResult: Models.ISpeedTestResult;
        public speedTestReloading: boolean = false;
        public pingReloading: boolean = false;
        public enumStatus = TestStatus;

        private nodeId: number;

        private graph: jquery.flot.plot;
        private graphOptions: jquery.flot.plotOptions;
        private initialDateTime: number;

        private totalBitrateArray: number[];
        private totalSimBitrateArray: number[];
        private serieColors: string[] = ['red', 'white', 'yellow', 'black', 'purple', 'blue', 'gold'];

        private restartEnabled: boolean;
        private udpPingRunning: boolean;
        private udpListenRunning: boolean;
        private blinkInterval: ng.IPromise<void>;
        private jobInterval: ng.IPromise<void>;
        private runningTestIndex: number;
        private runningTests: Test[];
        private networkConnectedTest: Test;
        private pingToFlexoTest: Test;
        private traceToFlexoTest: Test;
        private udpPingTest: Test;
        private udpListenTest: Test;
        private pingToGoogleTest: Test;
        private traceToGoogleTest: Test;
        private bandwidthTest: Test;
        private mvpAppScanTest: Test;
        private imaliveplusplusTest: Test;
        private getclientserversettingsTest: Test;
        private mgmtConnectedTest: Test;

        private mgmtInfo: Models.IManagementInfo;
        private clientInfo: Models.IClientInfo;
        private mvpAppScannerJob: Models.IJob;

        private destroyed: boolean = false;
        private deviceConected: boolean = false;

        private srtGateways: INetworkNode[];

        /**
         * Constructor of the class.
         */
        constructor(private $scope: ng.IScope,
                    private qService: ng.IQService,
                    private modalService: ngModal.IModalService,
                    private $timeout: ng.ITimeoutService,
                    private $interval: ng.IIntervalService,
                    private $routeParams: ng.route.IRouteParamsService,
                    private deviceGuiService: Services.DeviceGuiService,
                    private $sce: ng.ISCEService,
                    private networkElementService: Services.NetworkElementService,
                    private networkNodeService: Services.NetworkNodeService,
                    private gatewayService: Services.GatewayService,
                    private timezoneService: Services.TimezoneService,
                    private $location: ng.ILocationService,
                    private blockService: Services.BlockService,
                    private managementService: Services.ManagementService,
                    private probeService: Application.Services.ProbeService,
                    private mvpAppScannerJobService: Application.Services.MVPAppScannerJobService,
                    private mvpServerInfoService: Application.Services.MVPServerInfoService,
                    private clipboard: angular.AngularClipboard.ClipboardService,
                    private messageTranslationsService: Services.MessageTranslationsService,
                    private blockConnectionNodesService: Services.BlockConnectionNodesService,
                    ) {

            this.totalSimBitrateArray = new Array();
            this.totalBitrateArray = new Array();


            $timeout(() => {
                window.altair_admin_common_init();
                UIkit.accordion('.uk-accordion', { collapse: false, showfirst: false });
            }, 500);

            this.nodeId = parseInt(($routeParams as IRouteSupportParams).nodeId, 10);
            let paramBack: string = ($routeParams as IRouteSupportParams).backUrl;
            if (paramBack !== undefined)
                this.backUrl = paramBack;

            this.networkNodeService
                .getByIdPromise(this.nodeId)
                .then((node: Models.NetworkNode) => {
                    this.node = node;
                    this.qService.all([
                        this.blockService.findBlocksByNetworkNodeHrefAndBlockTypeNaturalKey(Common.Utils.strIdFromHref(node.href),
                                                                                            Models.BlockTypeNaturalKey.MVP_CLIENT),
                        this.blockService.findBlocksByNetworkNodeHrefAndBlockTypeNaturalKey(Common.Utils.strIdFromHref(node.href),
                                                                                            Models.BlockTypeNaturalKey.MVP_SERVER),
                        this.blockService.findBlocksByNetworkNodeHrefAndBlockTypeNaturalKey(Common.Utils.strIdFromHref(node.href),
                                                                                            Models.BlockTypeNaturalKey.MVP_SERVER_TS),
                    ])
                    .then((res: [Models.Block[], Models.Block[], Models.Block[]]) => {
                        let cBlocks: Models.Block[] = res[0],
                            sBlocks: Models.Block[] = res[1],
                            stsBlocks: Models.Block[] = res[2];

                        this.isClient = (cBlocks.length > 0);
                        this.isServerTS = (stsBlocks.length > 0);
                        this.isServer = (sBlocks.length > 0 || this.isServerTS);
                        this.isIO = this.isServer && this.isClient;

                        if (this.isServer) {
                            this.mvpServerInfoService
                                .getServerClientsInfo(Common.Utils.strIdFromHref(this.node.href))
                                .then((serverClients: Models.ServerClientsInfo) => {
                                    this.serverClients = serverClients;
                                    this.init();
                                    this.initTests();
                                    this.runTests();
                                });
                        } else {
                            this.init();
                            this.initTests();
                            this.runTests();
                        }
                    });
                });
            this.networkNodeService.getAllByNetworkNodeTypeId(19).then((srtGateways: Models.NetworkNode[]) => {
                this.srtGateways = srtGateways;
            });
        }

        public restartTests(): void {
            this.restartEnabled = false;
            this.initTests();
            this.runTests();
        }

        public restartUdpTests(): void {
            this.udpPingTest = new Test(this.$timeout, 10, Texts.UDP_PING_TEST_TITLE);
            this.runningTests.push(this.udpPingTest);
            this.defineUdpPingTestRun();
            this.udpPingTest.run();

            this.udpListenTest = new Test(this.$timeout, 11, Texts.UDP_LISTEN_TEST_TITLE);
            this.runningTests.push(this.udpListenTest);
            this.defineUdpListenTestRun();
            this.udpListenTest.run();
        }

        public testHasExecuted(test: Test): boolean {
            return (test && test.status !== TestStatus.WAITING &&
                    test.status !== TestStatus.NO_TEST &&
                    test.status !== TestStatus.IN_PROCESS);
        }

        public testNotPresent(test: Test): boolean {
            return (test && test.status === TestStatus.NO_TEST);
        }

        public getBadgeClassFromResult(result: Models.JobItemResult, clientId?: number): string {
            if (result === Models.JobItemResult.OK) {
                return "uk-badge-success";
            } else if (clientId !== undefined && this.clientIdConnectedInServer(clientId)) {
                // don't color it as failure if there's a client connected in this slot
                return "";
            } else {
                return "uk-badge-danger";
            }
        }

        public getBadgeClassFromServerClientId(clientId: number): string {
            if (this.serverClients) {
                return this.clientIdConnectedInServer(clientId) && this.node.health.data.healthStatus === 'ONLINE'
                    ? "uk-badge-success" : "uk-badge-info";
            } else {
                return "";
            }
        }

        public getLabelFromServerClientId(clientId: number): string {
            if (this.serverClients) {
                return this.clientIdConnectedInServer(clientId) && this.node.health.data.healthStatus === 'ONLINE'
                    ? "Connected" : "Listen";
            } else {
                return "Unknown";
            }
        }

        public kbpsToMpbs(kbps: number): number {
            return parseFloat((kbps / 1000).toFixed(2));
        };

        public runTestInBg(e: JQueryEventObject): void {
            e.stopPropagation();
            this.runTests();
        }

        public summarize(): void {
            let summary: string = this.getSummary();
            this.clipboard.copyText(summary);
            Common.Utils.alertOnInfo('Summary copied to clipboard');
        }

        private getSummary(): string {
            let summary: string = "Test date: " + this.startDate.toString() + "\n";
            summary += "Node: " + this.node.name + (this.node.alias && this.node.alias !== "" ? " (" + this.node.alias + ")" : "") + "\n";
            summary += "Serial: " + this.node.mftSerialNumber + "\n";
            summary += "Type: " + this.node.type.name + "\n";
            summary += "Contact info: " +
                (this.node.contactInfo && this.node.contactInfo !== "" ? this.node.contactInfo : "No info") + "\n\n";

            this.runningTests.forEach((test: Test) => {
                summary += "[" + TestStatus[test.status] + "] " + test.title + ": " + test.result + "\n";
                summary += (test.info !== '' ? "Info: " + test.info + "\n" : "");
                summary += (test.data && test.data !== '' ? "Data: " + test.data.toString() + "\n" : "");
                summary += "\n";
            });
            return summary;
        }

        private initTests(): void {
            this.startDate = new Date();
            this.graph = undefined;

            this.mgmtConnectedTest = new Test(this.$timeout, 0, Texts.MGMT_SERVER_TEST_TITLE);
            this.imaliveplusplusTest = new Test(this.$timeout, 1, Texts.IMALIVEPLUSPLUS_TEST_TITLE);
            this.getclientserversettingsTest = new Test(this.$timeout, 2, Texts.GETCLIENTSERVER_TEST_TITLE);
            this.networkConnectedTest = new Test(this.$timeout, 3, Texts.NETWORK_CONN_TEST_TITLE);
            this.pingToFlexoTest = new Test(this.$timeout, 4, Texts.PING_FLEXO_TEST_TITLE);
            this.traceToFlexoTest = new Test(this.$timeout, 5, Texts.TRACE_FLEXO_TEST_TITLE);
            this.pingToGoogleTest = new Test(this.$timeout, 6, Texts.PING_GOOGLE_TEST_TITLE);
            this.traceToGoogleTest = new Test(this.$timeout, 7, Texts.TRACE_GOOGLE_TEST_TITLE);
            this.bandwidthTest = new Test(this.$timeout, 8, Texts.BW_TEST_TITLE);
            this.mvpAppScanTest = new Test(this.$timeout, 9, Texts.MVP_SCAN_TEST_TITLE);
            this.udpPingTest = new Test(this.$timeout, 10, Texts.UDP_PING_TEST_TITLE);
            this.udpListenTest = new Test(this.$timeout, 11, Texts.UDP_LISTEN_TEST_TITLE);

            this.defineTestsRun();

            // Order is important, as there are dependencies between tests
            this.runningTestIndex = -1;
            this.runningTests = [];
            this.runningTests.push(this.mgmtConnectedTest);
            this.runningTests.push(this.imaliveplusplusTest);
            this.runningTests.push(this.getclientserversettingsTest);
            this.runningTests.push(this.networkConnectedTest);
            this.runningTests.push(this.pingToFlexoTest);
            this.runningTests.push(this.traceToFlexoTest);
            this.runningTests.push(this.pingToGoogleTest);
            this.runningTests.push(this.traceToGoogleTest);
            this.runningTests.push(this.bandwidthTest);
            this.runningTests.push(this.mvpAppScanTest);
            this.runningTests.push(this.udpPingTest);
            this.runningTests.push(this.udpListenTest);
        }

        private defineTestsRun(): void {
            this.networkNodeService.startSupportTest(this.node);
            this.mgmtConnectedTest.run = () => {
                this.mgmtConnectedTest.setStatus(TestStatus.IN_PROCESS);

                if (this.node.type.vendor !== Models.NetworkNodeTypeVendor.MVP) {
                    this.mgmtConnectedTest.setStatus(TestStatus.NO_TEST);
                    this.runTests();
                } else {
                    this.managementService.getManagementInfo(this.node.mftSerialNumber)
                    .then((mgmtInfo: Models.IManagementInfo) => {
                        if (!this.destroyed) {
                            this.mgmtInfo = mgmtInfo;
                            this.mgmtInfo.result ? this.mgmtConnectedTest.setStatus(TestStatus.PASS) :
                                                this.mgmtConnectedTest.setStatus(TestStatus.FAIL);
                            this.mgmtConnectedTest.result = this.mgmtInfo.result ? Texts.MGMT_SERVER_TEST_RESULT_PASS :
                                                                                Texts.MGMT_SERVER_TEST_RESULT_FAIL;
                            if (this.mgmtConnectedTest.status === TestStatus.PASS) {
                                this.mgmtConnectedTest.info = Texts.MGMT_SERVER_TEST_INFO_PASS;
                            } else if (this.mgmtConnectedTest.status === TestStatus.FAIL) {
                                this.mgmtConnectedTest.info = this.messageTranslationsService
                                                                  .getMessageAsStringByKeySync('test.info.mgmt.server.fail');
                            }

                            if (this.mgmtConnectedTest.status === TestStatus.PASS && (this.isClient && !this.isServer)) {
                                this.managementService.getClientInfo(this.node.mftSerialNumber)
                                .then((clientInfo: Models.IClientInfo) => {
                                    this.clientInfo = clientInfo;
                                }).catch(() => {
                                    // do nothing
                                });
                            }

                            this.runTests();
                        }
                    }).catch(() => {
                        if (!this.destroyed) {
                            this.mgmtConnectedTest.setStatus(TestStatus.FAIL);
                            this.mgmtConnectedTest.result = Texts.MGMT_SERVER_TEST_RESULT_TEST_FAIL;
                            this.runTests();
                        }
                    });
                }
            };

            this.imaliveplusplusTest.run = () => {
                this.imaliveplusplusTest.setStatus(TestStatus.IN_PROCESS);

                if (this.node.type.vendor !== Models.NetworkNodeTypeVendor.MVP || (this.isClient && !this.isIO) || this.isServerTS) {
                    this.imaliveplusplusTest.setStatus(TestStatus.NO_TEST);
                } else {
                    this.node.health.data.checks.forEach((check: Models.INodeCheck) => {
                        if (check.name === 'MVP/ImAliveplusplus') {
                            check.healthStatus === 'ONLINE' ?
                                    this.imaliveplusplusTest.setStatus(TestStatus.PASS) :
                                    this.imaliveplusplusTest.setStatus(TestStatus.FAIL);
                            this.imaliveplusplusTest.result = Texts.IMALIVEPLUSPLUS_TEST_RESULT + check.healthStatus;

                            if (this.imaliveplusplusTest.status === TestStatus.PASS) {
                                this.imaliveplusplusTest.info = check.output;
                            } else if (this.imaliveplusplusTest.status === TestStatus.FAIL) {
                                this.imaliveplusplusTest.info = this.messageTranslationsService
                                                                    .getMessageAsStringByKeySync('test.info.imaliveplusplus.fail');
                            }
                        }
                    });

                    if (this.imaliveplusplusTest.status === TestStatus.IN_PROCESS) {
                        this.imaliveplusplusTest.setStatus(TestStatus.FAIL);
                        this.imaliveplusplusTest.result = Texts.NO_CALL_INFO;
                    }
                }

                this.runTests();
            };

            this.getclientserversettingsTest.run = () => {
                this.getclientserversettingsTest.setStatus(TestStatus.IN_PROCESS);

                if (this.node.type.vendor !== Models.NetworkNodeTypeVendor.MVP || this.isServer) {
                    this.getclientserversettingsTest.setStatus(TestStatus.NO_TEST);
                } else {
                    this.node.health.data.checks.forEach((check: Models.INodeCheck) => {
                        if (check.name === 'MVP/GetClientServerSettings') {
                            check.healthStatus === 'ONLINE' ? this.getclientserversettingsTest.setStatus(TestStatus.PASS) :
                                                              this.getclientserversettingsTest.setStatus(TestStatus.FAIL);
                            this.getclientserversettingsTest.result = Texts.GETCLIENTSERVER_TEST_RESULT + check.healthStatus;

                            if (this.getclientserversettingsTest.status === TestStatus.PASS) {
                                this.getclientserversettingsTest.info = check.output;
                            } else if (this.getclientserversettingsTest.status === TestStatus.FAIL) {
                                this.getclientserversettingsTest.info = Texts.GETCLIENTSERVER_TEST_INFO_FAIL;
                            }
                        }
                    });

                    if (this.getclientserversettingsTest.status === TestStatus.IN_PROCESS) {
                        this.getclientserversettingsTest.setStatus(TestStatus.FAIL);
                        this.getclientserversettingsTest.result = Texts.NO_CALL_INFO;
                    }
                }

                this.runTests();
            };

            this.networkConnectedTest.run = () => {
                this.networkConnectedTest.setStatus(TestStatus.IN_PROCESS);

                if (this.node.networkInterfaces.some((nic: Models.INetworkInterface) => nic.connected)) {
                    this.networkConnectedTest.setStatus(TestStatus.PASS);
                    this.networkConnectedTest.result = Texts.NETWORK_CONN_TEST_RESULT_PASS;
                    this.networkConnectedTest.info = Texts.NETWORK_CONN_TEST_INFO_PASS;
                } else {
                    this.networkConnectedTest.setStatus(TestStatus.FAIL);
                    this.networkConnectedTest.result = Texts.NETWORK_CONN_TEST_RESULT_FAIL;
                    this.networkConnectedTest.info = Texts.NETWORK_CONN_TEST_INFO_FAIL;
                }

                this.runTests();
            };

            this.pingToFlexoTest.run = () => {
                this.pingToFlexoTest.setStatus(TestStatus.IN_PROCESS);

                if (this.networkConnectedTest.status === TestStatus.FAIL) {
                    this.pingToFlexoTest.setStatus(TestStatus.FAIL);
                    this.pingToFlexoTest.result = Texts.NETWORK_CONN_TEST_RESULT_FAIL;
                    this.pingToFlexoTest.info = Texts.NETWORK_CONN_TEST_INFO_FAIL;
                    this.runTests();
                } else if (this.node.type.vendor !== Models.NetworkNodeTypeVendor.MVP || !this.isServer) {
                    this.pingToFlexoTest.setStatus(TestStatus.NO_TEST);
                    this.runTests();
                } else {
                    // Tries to reach Flexo (id:1) on TCP port 443. Not really true, as we are pinging, but should work
                    this.networkElementService.getMappingFromNodeToNode(
                        new Models.MappingInfoRequest(Common.Utils.idFromHref(this.node.href), 1, "443", "TCP", "ANY"))
                    .then((mappingToFlexo: Models.MappingInfo) => {
                        if (!this.destroyed) {
                            this.mappingToFlexo = mappingToFlexo;
                            // Tries to reach Device from Flexo (id:1) on TCP port 7071
                            this.networkElementService.getMappingFromNodeToNode(
                                new Models.MappingInfoRequest(1, Common.Utils.idFromHref(this.node.href), "7071", "TCP", "ANY"))
                            .then((mappingFromFlexo: Models.MappingInfo) => {
                                if (!this.destroyed) {
                                    this.mappingFromFlexo = mappingFromFlexo;
                                    if (this.mappingToFlexo !== undefined) {
                                        if (mappingFromFlexo !== undefined || 
                                            this.mgmtConnectedTest.status === TestStatus.PASS) {
                                            this.flexoPing();
                                        } else {
                                            this.pingToFlexoTest.setStatus(TestStatus.FAIL);
                                            this.pingToFlexoTest.result =  Texts.TEST_RESULT_FAIL_NO_MAPPING_FROM_FLEXO;
                                            this.pingToFlexoTest.info = this.messageTranslationsService
                                                                            .getMessageAsStringByKeySync('error.no.mapping.from.flexo');
                                            this.runTests();
                                        }
                                    } else {
                                        this.pingToFlexoTest.setStatus(TestStatus.FAIL);
                                        this.pingToFlexoTest.result =  Texts.TEST_RESULT_FAIL_NO_MAPPING_TO_FLEXO;
                                        this.pingToFlexoTest.info = this.messageTranslationsService
                                                                        .getMessageAsStringByKeySync('error.no.mapping.to.flexo');
                                        this.runTests();
                                    }
                                }
                            });
                        }
                    });
                }
            };

            this.traceToFlexoTest.run = () => {
                this.traceToFlexoTest.setStatus(TestStatus.IN_PROCESS);

                if (this.networkConnectedTest.status === TestStatus.FAIL) {
                    this.traceToFlexoTest.setStatus(TestStatus.FAIL);
                    this.traceToFlexoTest.result = Texts.NETWORK_CONN_TEST_RESULT_FAIL;
                    this.traceToFlexoTest.info = Texts.NETWORK_CONN_TEST_INFO_FAIL;
                    this.runTests();
                } else if (this.node.type.vendor !== Models.NetworkNodeTypeVendor.MVP || !this.isServer) {
                    this.traceToFlexoTest.setStatus(TestStatus.NO_TEST);
                    this.runTests();
                } else {
                    if (this.mappingToFlexo !== undefined) {
                        if (this.mappingFromFlexo !== undefined || this.mgmtConnectedTest.status === TestStatus.PASS) {
                            this.flexoTraceroute();
                        } else {
                            this.traceToFlexoTest.setStatus(TestStatus.FAIL);
                            this.traceToFlexoTest.result =  Texts.TEST_RESULT_FAIL_NO_MAPPING_FROM_FLEXO;
                            this.traceToFlexoTest.info = this.messageTranslationsService
                                                             .getMessageAsStringByKeySync('error.no.mapping.from.flexo');
                            this.runTests();
                        }
                    } else {
                        this.traceToFlexoTest.setStatus(TestStatus.FAIL);
                        this.traceToFlexoTest.result =  Texts.TEST_RESULT_FAIL_NO_MAPPING_TO_FLEXO;
                        this.traceToFlexoTest.info = this.messageTranslationsService
                                                         .getMessageAsStringByKeySync('error.no.mapping.to.flexo');
                        this.runTests();
                    }
                }
            };


            this.pingToGoogleTest.run = () => {
                this.pingToGoogleTest.setStatus(TestStatus.IN_PROCESS);

                if (this.networkConnectedTest.status === TestStatus.FAIL) {
                    this.pingToGoogleTest.setStatus(TestStatus.FAIL);
                    this.pingToGoogleTest.result = Texts.NETWORK_CONN_TEST_RESULT_FAIL;
                    this.pingToGoogleTest.info = Texts.NETWORK_CONN_TEST_INFO_FAIL;
                    this.runTests();
                } else if (this.node.type.vendor !== Models.NetworkNodeTypeVendor.MVP || !this.isServer) {
                    this.pingToGoogleTest.setStatus(TestStatus.NO_TEST);
                    this.runTests();
                } else {
                    if (this.mappingFromFlexo !== undefined || this.mgmtConnectedTest.status === TestStatus.PASS) {
                        this.googlePing();
                    } else {
                        this.pingToGoogleTest.setStatus(TestStatus.FAIL);
                        this.pingToGoogleTest.result =  Texts.TEST_RESULT_FAIL_NO_MAPPING_FROM_FLEXO;
                        this.pingToGoogleTest.info = this.messageTranslationsService
                                                         .getMessageAsStringByKeySync('error.no.mapping.from.flexo');
                        this.runTests();
                    }
                }
            };

            this.traceToGoogleTest.run = () => {
                this.traceToGoogleTest.setStatus(TestStatus.IN_PROCESS);

                if (this.networkConnectedTest.status === TestStatus.FAIL) {
                    this.traceToGoogleTest.setStatus(TestStatus.FAIL);
                    this.traceToGoogleTest.result = Texts.NETWORK_CONN_TEST_RESULT_FAIL;
                    this.traceToGoogleTest.info = Texts.NETWORK_CONN_TEST_INFO_FAIL;
                    this.runTests();
                } else if (this.node.type.vendor !== Models.NetworkNodeTypeVendor.MVP || !this.isServer) {
                    this.traceToGoogleTest.setStatus(TestStatus.NO_TEST);
                    this.runTests();
                } else {
                    if (this.mappingFromFlexo !== undefined || this.mgmtConnectedTest.status === TestStatus.PASS) {
                        this.googleTraceroute();
                    } else {
                        this.traceToGoogleTest.setStatus(TestStatus.FAIL);
                        this.traceToGoogleTest.result =  Texts.TEST_RESULT_FAIL_NO_MAPPING_FROM_FLEXO;
                        this.traceToGoogleTest.info = this.messageTranslationsService
                                                          .getMessageAsStringByKeySync('error.no.mapping.from.flexo');
                        this.runTests();
                    }
                }
            };

            this.bandwidthTest.run = () => {
                this.bandwidthTest.setStatus(TestStatus.IN_PROCESS);
                this.checkInUse().then((connected: boolean ) => {
                    this.deviceConected = connected;

                    if (this.networkConnectedTest.status === TestStatus.FAIL) {
                        this.bandwidthTest.setStatus(TestStatus.FAIL);
                        this.bandwidthTest.result = Texts.NETWORK_CONN_TEST_RESULT_FAIL;
                        this.bandwidthTest.info = Texts.NETWORK_CONN_TEST_INFO_FAIL;
                        this.runTests();
                    }else if (this.node.type.vendor !== Models.NetworkNodeTypeVendor.MVP || !this.isServer) {
                        this.bandwidthTest.setStatus(TestStatus.NO_TEST);
                        this.runTests();
                    }
                    else if (this.deviceConected) {
                        this.bandwidthTest.setStatus(TestStatus.DEVICE_IN_USE);
                        this.runTests();
                    }

                    else {
                        if (this.mappingFromFlexo !== undefined || this.mgmtConnectedTest.status === TestStatus.PASS) {
                            this.speedTest();
                        } else {
                            this.bandwidthTest.setStatus(TestStatus.FAIL);
                            this.bandwidthTest.result =  Texts.TEST_RESULT_FAIL_NO_MAPPING_FROM_FLEXO;
                            this.bandwidthTest.info = this.messageTranslationsService
                                                          .getMessageAsStringByKeySync('error.no.mapping.from.flexo');
                            this.runTests();
                        }
                    }
                });
            };

            this.mvpAppScanTest.run = () => {
                this.mvpAppScanTest.setStatus(TestStatus.IN_PROCESS);

                if (this.networkConnectedTest.status === TestStatus.FAIL) {
                    this.mvpAppScanTest.setStatus(TestStatus.FAIL);
                    this.mvpAppScanTest.result = Texts.NETWORK_CONN_TEST_RESULT_FAIL;
                    this.mvpAppScanTest.info = Texts.NETWORK_CONN_TEST_INFO_FAIL;
                    this.runTests();
                } else if (this.node.type.vendor !== Models.NetworkNodeTypeVendor.MVP || !this.isServer) {
                    this.mvpAppScanTest.setStatus(TestStatus.NO_TEST);
                    this.runTests();
                } else {
                    this.probeService.getFlexoProbe((flexo: Models.Probe) => {
                        if (flexo !== undefined) {
                            let jobRequest: Models.IJobRequest = new Models.MVPAppScannerJobRequest();
                            jobRequest.probeId = Common.Utils.idFromHref(flexo.href);
                            jobRequest.jobInfo.networkElementHref = Common.Utils.idFromHref(this.node.href);
                            jobRequest.jobInfo.networkNode = this.node;
                            jobRequest.jobInfo.networkNodeType = this.node.type;

                            this.mvpAppScannerJobService.createMVPAppScannerJob(jobRequest)
                            .then((newJob: Models.IJob) => {
                                this.mvpAppScannerJob = newJob;

                                this.jobInterval = this.$interval(() => {
                                    this.mvpAppScannerJobService.getJobById(this.mvpAppScannerJob.jobId)
                                    .then((job: Models.MVPAppScannerJob) => {
                                        if (!this.destroyed) {
                                            if (job.jobStatus === Models.JobStatus.FINISHED ||
                                                job.jobStatus === Models.JobStatus.ERROR) {
                                                this.$interval.cancel(this.jobInterval);
                                                this.analyzeMVPAppScanTestResult(job);
                                                this.mvpAppScannerJobService.deleteJobById(this.mvpAppScannerJob.jobId);
                                                this.runTests();
                                            }
                                        }
                                    }).catch(() => {
                                        if (!this.destroyed) {
                                            this.$interval.cancel(this.jobInterval);
                                            this.mvpAppScanTest.setStatus(TestStatus.FAIL);
                                            this.mvpAppScanTest.result = Texts.TEST_RESULT_FAIL_EXEC;
                                            this.mvpAppScanTest.info = "";
                                            this.runTests();
                                        }
                                    });
                                }, 2000);
                            });
                        } else {
                            if (!this.destroyed) {
                                this.mvpAppScanTest.setStatus(TestStatus.FAIL);
                                this.mvpAppScanTest.result = Texts.TEST_RESULT_FAIL_EXEC;
                                this.mvpAppScanTest.info = "";
                                this.runTests();
                            }
                        }
                    });
                }
            };

            this.defineUdpPingTestRun();

            this.defineUdpListenTestRun();
        }

        private defineUdpPingTestRun() {
            this.udpPingTest.run = () => {
                this.udpPingTest.setStatus(TestStatus.IN_PROCESS);

                if (this.networkConnectedTest.status === TestStatus.FAIL) {
                    this.udpPingTest.setStatus(TestStatus.FAIL);
                    this.udpPingTest.result = Texts.NETWORK_CONN_TEST_RESULT_FAIL;
                    this.udpPingTest.info = Texts.NETWORK_CONN_TEST_INFO_FAIL;
                    this.runTests();
                } else if (this.node.type.vendor !== Models.NetworkNodeTypeVendor.MVP || !this.isServer) {
                    this.udpPingTest.setStatus(TestStatus.NO_TEST);
                    this.runTests();
                } else {
                    if (this.mgmtConnectedTest.status === TestStatus.PASS) {
                        if (this.targetSrt) {
                            this.flexoUdpPingEndToEndTest();
                        } else {
                            this.udpPingTest.setStatus(TestStatus.NO_TEST);
                            this.udpPingTest.result = Texts.TEST_RESULT_NO_TARGET_SRT_SELECTED;
                            this.udpPingTest.info = Texts.TEST_RESULT_NO_TARGET_SRT_SELECTED;
                            this.runTests();
                        }
                    } else {
                        this.udpPingTest.setStatus(TestStatus.FAIL);
                        this.udpPingTest.result = Texts.TEST_RESULT_FAIL_NO_MAPPING_FROM_FLEXO;
                        this.udpPingTest.info = this.messageTranslationsService
                            .getMessageAsStringByKeySync('error.no.mapping.from.flexo');
                        this.runTests();
                    }
                }
            };
        }

        private defineUdpListenTestRun() {
            this.udpListenTest.run = () => {
                this.udpListenTest.setStatus(TestStatus.IN_PROCESS);

                if (this.networkConnectedTest.status === TestStatus.FAIL) {
                    this.udpListenTest.setStatus(TestStatus.FAIL);
                    this.udpListenTest.result = Texts.NETWORK_CONN_TEST_RESULT_FAIL;
                    this.udpListenTest.info = Texts.NETWORK_CONN_TEST_INFO_FAIL;
                    this.runTests();
                } else if (this.node.type.vendor !== Models.NetworkNodeTypeVendor.MVP || !this.isServer) {
                    this.udpListenTest.setStatus(TestStatus.NO_TEST);
                    this.runTests();
                } else {
                    if (this.mgmtConnectedTest.status === TestStatus.PASS) {
                        if (this.targetSrt) {
                            this.flexoUdpListenEndToEndTest();
                        } else {
                            this.udpListenTest.setStatus(TestStatus.NO_TEST);
                            this.udpListenTest.result = Texts.TEST_RESULT_NO_TARGET_SRT_SELECTED;
                            this.udpListenTest.info = Texts.TEST_RESULT_NO_TARGET_SRT_SELECTED;
                            this.runTests();
                        }
                    } else {
                        this.udpListenTest.setStatus(TestStatus.FAIL);
                        this.udpListenTest.result = Texts.TEST_RESULT_FAIL_NO_MAPPING_FROM_FLEXO;
                        this.udpListenTest.info = this.messageTranslationsService
                            .getMessageAsStringByKeySync('error.no.mapping.from.flexo');
                        this.runTests();
                    }
                }
            };
        }

        private runTests(): void {
            if (this.runningTestIndex < this.runningTests.length - 1) {
                this.runningTestIndex++;
                this.runningTests[this.runningTestIndex].run();
            } else {
                this.runningTestIndex++;
                this.restartEnabled = true;
                this.networkNodeService.endSupportTest(this.node, this.getSummary());
            }
        }

        private init(): void {
            this.$scope.$on('$destroy', () => {
                this.destroyed = true;

                let speedGraph: JQuery.IJQueryFlotBind = $('#speed-test-graph');
                if (speedGraph.length) {
                    speedGraph.unbind("plothover");
                }

                if (this.graph) {
                    this.graph.destroy();
                    this.graph = undefined;
                }

                if (this.blinkInterval) {
                    this.$interval.cancel(this.blinkInterval);
                }

                if (this.jobInterval) {
                    this.$interval.cancel(this.jobInterval);
                }
            });

            this.blinkInterval = this.$interval(() => {
                this.runningTests.forEach((test: Test) => {
                    test.blink();
                });
            }, 500);
        }

        private analyzeMVPAppScanTestResult(job: Models.MVPAppScannerJob): void {
            if (job.jobResult) {
                let someOK: boolean = job.jobResult.appConnections.some(
                    (appConn: Models.AppConnection) => appConn.result === Models.JobItemResult.OK);
                let someFAIL: boolean = job.jobResult.appConnections.some(
                    (appConn: Models.AppConnection) => appConn.result === Models.JobItemResult.FAIL);

                job.jobResult.clients.forEach((client: Models.Client) => {
                    someOK = someOK || client.connections.some(
                        (conn: Models.Connection) => conn.result === Models.JobItemResult.OK);

                    // if we know there's a client connected in this slot, ignore failures
                    if (!this.clientIdConnectedInServer(client.id)) {
                        someFAIL = someFAIL || client.connections.some(
                            (conn: Models.Connection) => conn.result === Models.JobItemResult.FAIL);
                    }
                });

                someOK = someOK || job.jobResult.rtmp.result === Models.JobItemResult.OK;
                someFAIL = someFAIL || job.jobResult.rtmp.result === Models.JobItemResult.FAIL;

                someOK = someOK || job.jobResult.http.some((http: Models.JobResultHTTP) => http.result === Models.JobItemResult.OK);
                someFAIL = someFAIL || job.jobResult.http.some((http: Models.JobResultHTTP) => http.result === Models.JobItemResult.FAIL);

                if (someOK && someFAIL) {
                    this.mvpAppScanTest.setStatus(TestStatus.WARN);
                    this.mvpAppScanTest.result = Texts.MVP_SCAN_TEST_RESULT_WARN;
                    this.mvpAppScanTest.info = Texts.MVP_SCAN_TEST_INFO_WARN;
                } else if (someOK) {
                    this.mvpAppScanTest.setStatus(TestStatus.PASS);
                    this.mvpAppScanTest.result = Texts.MVP_SCAN_TEST_RESULT_PASS;
                    this.mvpAppScanTest.info = "";
                } else {
                    this.mvpAppScanTest.setStatus(TestStatus.FAIL);
                    this.mvpAppScanTest.result = Texts.MVP_SCAN_TEST_RESULT_FAIL;
                    this.mvpAppScanTest.info = Texts.MVP_SCAN_TEST_INFO_FAIL;
                }

                if (job.jobErrorMessage) {
                    if (this.mvpAppScanTest.info !== "") {
                        this.mvpAppScanTest.info = job.jobErrorMessage + "\n\n" + this.mvpAppScanTest.info;
                    } else {
                        this.mvpAppScanTest.info = job.jobErrorMessage;
                    }
                }

                this.mvpAppScanTest.data = Models.MVPAppScannerJobResult.burnish(job.jobResult);
                (this.mvpAppScanTest.data as Models.MVPAppScannerJobResult).serverClients = this.serverClients;
            } else {
                this.mvpAppScanTest.setStatus(TestStatus.FAIL);
                this.mvpAppScanTest.result = Texts.TEST_RESULT_FAIL_EXEC;
                if (job.jobErrorMessage) {
                    this.mvpAppScanTest.info = job.jobErrorMessage;
                }
            }
        }

        private flexoPing(): void {
            this.pingReloading = true;
            this.networkNodeService.getNodePingTest(this.node, this.mappingToFlexo.ipAddress).then((result: Models.ITestResult) => {
                if (!this.destroyed) {
                    this.pingReloading = false;
                    this.flexoPingResult = result;
                    this.pingToFlexoTest.data = result.result;
                    this.analyzeFlexoPing();
                    this.runTests();
                }
            }).catch((reason: ngCustom.IReason) => {
                if (!this.destroyed) {
                    this.pingReloading = false;
                    this.flexoPingResult = reason.data as Models.ITestResult;

                    if (reason.data && reason.data.error) {
                        this.pingToFlexoTest.data = reason.data.error;
                        if (reason.data.error.indexOf("ConnectTimeoutException") !== -1) {
                            this.pingToFlexoTest.result = Texts.TEST_RESULT_FAIL_TIMEOUT;
                            this.pingToFlexoTest.info = Texts.TEST_INFO_FAIL_TIMEOUT;
                        } else if (reason.data.error.indexOf("HttpHostConnectException") !== -1) {
                            this.pingToFlexoTest.result = Texts.TEST_RESULT_FAIL_CONN;
                            this.pingToFlexoTest.info = Texts.TEST_INFO_FAIL_CONN;
                        } else if (reason.data.error.indexOf("NoRouteToHostException") !== -1) {
                            this.pingToFlexoTest.result = Texts.TEST_RESULT_FAIL_NOROUTE;
                            this.pingToFlexoTest.info = Texts.TEST_INFO_FAIL_NOROUTE;
                        } else {
                            this.pingToFlexoTest.result = Texts.TEST_RESULT_FAIL_EXEC;
                            this.pingToFlexoTest.info = "";
                        }
                    } else {
                        this.pingToFlexoTest.result = Texts.TEST_RESULT_FAIL_EXEC;
                        this.pingToFlexoTest.info = "";
                    }

                    this.pingToFlexoTest.setStatus(TestStatus.FAIL);
                    this.runTests();
                }
            });
        }

        private analyzeFlexoPing(): void {
            try {
                // parsing ping results is ugly, but works
                let lines: string[] = this.flexoPingResult.result.split('\n');
                let stats1: string , stats2: string;
                [stats1, stats2]  = this.findPingStatistics(lines);
                if (stats1 && stats1.indexOf(" 0% packet loss") > -1) {
                    if (stats2) {
                        let avg: number = parseFloat(stats2.split(" ")[3].split("/")[1]);
                        let mdev: number = parseFloat(stats2.split(" ")[3].split("/")[3]);
                        if (avg < 250) {
                            if (mdev < 50) {
                                this.pingToFlexoTest.setStatus(TestStatus.PASS);
                                this.pingToFlexoTest.result = Texts.PING_TEST_RESULT_PASS;
                                this.pingToFlexoTest.info = "";
                            } else {
                                this.pingToFlexoTest.setStatus(TestStatus.WARN);
                                this.pingToFlexoTest.result = Texts.PING_TEST_RESULT_WARN_HIGH_DEV.replace("%MS%", mdev.toString());
                                this.pingToFlexoTest.info = Texts.PING_TEST_INFO_WARN_HIGH_DEV;
                            }
                        } else {
                            this.pingToFlexoTest.setStatus(TestStatus.WARN);
                            this.pingToFlexoTest.result = Texts.PING_TEST_RESULT_WARN_HIGH_AVG.replace("%MS%", mdev.toString());
                            this.pingToFlexoTest.info = Texts.PING_TEST_INFO_WARN_HIGH_AVG;
                        }
                    } else {
                        this.pingToFlexoTest.setStatus(TestStatus.WARN);
                        this.pingToFlexoTest.result = Texts.PING_TEST_RESULT_WARN_NO_AVG;
                        this.pingToFlexoTest.info = Texts.PING_TEST_INFO_WARN_NO_AVG;
                    }
                } else {
                    if (stats1) {
                        this.pingToFlexoTest.setStatus(TestStatus.FAIL);
                        this.pingToFlexoTest.result = Texts.PING_TEST_RESULT_FAIL_LOSS;
                        this.pingToFlexoTest.info = Texts.PING_TEST_INFO_FAIL_LOSS;
                    } else {
                        this.pingToFlexoTest.setStatus(TestStatus.WARN);
                        this.pingToFlexoTest.result = Texts.TEST_RESULT_FAIL_PARSE;
                        this.pingToFlexoTest.info = Texts.TEST_INFO_WARN_CANT_PARSE;
                    }
                }
            } catch (e) {
                this.pingToFlexoTest.setStatus(TestStatus.WARN);
                this.pingToFlexoTest.result = Texts.TEST_RESULT_FAIL_PARSE;
                this.pingToFlexoTest.info = Texts.TEST_INFO_WARN_CANT_PARSE;
            }
        }

        private findPingStatistics(lines: string[]): string[] {
            let result: string[] = new Array();
            lines.forEach((line: string, index: number) => {
                if (line.indexOf("ping statistics") >= 0) {
                    if (lines.length > index + 1) {
                        result.push(lines[index + 1]);
                    } else {
                        result.push(undefined);
                    }
                    if (lines.length > index + 2) {
                        result.push(lines[index + 2]);
                    } else {
                        result.push(undefined);
                    }
                    return;
                }
            });
            return result;
        }

        private googlePing(): void {
            this.pingReloading = true;
            this.networkNodeService.getNodePingTest(this.node, this.pingGoogleIp).then((result: Models.ITestResult) => {
                if (!this.destroyed) {
                    this.pingReloading = false;
                    this.googlePingResult = result;
                    this.pingToGoogleTest.data = result.result;
                    this.analyzeGooglePing();
                    this.runTests();
                }
            }).catch((reason: ngCustom.IReason) => {
                if (!this.destroyed) {
                    this.pingReloading = false;
                    this.googlePingResult = reason.data as Models.ITestResult;

                    if (reason.data && reason.data.error) {
                        this.pingToGoogleTest.data = reason.data.error;
                        if (reason.data.error.indexOf("ConnectTimeoutException") !== -1) {
                            this.pingToGoogleTest.result = Texts.TEST_RESULT_FAIL_TIMEOUT;
                            this.pingToGoogleTest.info = Texts.TEST_INFO_FAIL_TIMEOUT;
                        } else if (reason.data.error.indexOf("HttpHostConnectException") !== -1) {
                            this.pingToGoogleTest.result = Texts.TEST_RESULT_FAIL_CONN;
                            this.pingToGoogleTest.info = Texts.TEST_INFO_FAIL_CONN;
                        } else if (reason.data.error.indexOf("NoRouteToHostException") !== -1) {
                            this.pingToGoogleTest.result = Texts.TEST_RESULT_FAIL_NOROUTE;
                            this.pingToGoogleTest.info = Texts.TEST_INFO_FAIL_NOROUTE;
                        } else {
                            this.pingToGoogleTest.result = Texts.TEST_RESULT_FAIL_EXEC;
                            this.pingToGoogleTest.info = "";
                        }
                    } else {
                        this.pingToGoogleTest.result = Texts.TEST_RESULT_FAIL_EXEC;
                        this.pingToGoogleTest.info = "";
                    }

                    this.pingToGoogleTest.setStatus(TestStatus.FAIL);
                    this.runTests();
                }
            });
        }

        private analyzeGooglePing(): void {
            try {
                // parsing ping results is ugly, but works
                let lines: string[] = this.googlePingResult.result.split('\n');
                let stats1: string , stats2: string;
                [stats1, stats2]  = this.findPingStatistics(lines);

                if (stats1 && stats1.indexOf(" 0% packet loss") > -1) {
                    if (stats2) {
                        let avg: number = parseFloat(stats2.split(" ")[3].split("/")[1]);
                        let mdev: number = parseFloat(stats2.split(" ")[3].split("/")[3]);
                        if (avg < 250) {
                            if (mdev < 50) {
                                this.pingToGoogleTest.setStatus(TestStatus.PASS);
                                this.pingToGoogleTest.result = Texts.PING_TEST_RESULT_PASS;
                                this.pingToGoogleTest.info = "";
                            } else {
                                this.pingToGoogleTest.setStatus(TestStatus.WARN);
                                this.pingToGoogleTest.result = Texts.PING_TEST_RESULT_WARN_HIGH_DEV.replace("%MS%", mdev.toString());
                                this.pingToGoogleTest.info = Texts.PING_TEST_INFO_WARN_HIGH_DEV;
                            }
                        } else {
                            this.pingToGoogleTest.setStatus(TestStatus.WARN);
                            this.pingToGoogleTest.result = Texts.PING_TEST_RESULT_WARN_HIGH_AVG.replace("%MS%", mdev.toString());
                            this.pingToGoogleTest.info = Texts.PING_TEST_INFO_WARN_HIGH_AVG;
                        }
                    } else {
                        this.pingToGoogleTest.setStatus(TestStatus.WARN);
                        this.pingToGoogleTest.result = Texts.PING_TEST_RESULT_WARN_NO_AVG;
                        this.pingToGoogleTest.info = Texts.PING_TEST_INFO_WARN_NO_AVG;
                    }
                } else {
                    if (stats1) {
                        this.pingToGoogleTest.setStatus(TestStatus.FAIL);
                        this.pingToGoogleTest.result = Texts.PING_TEST_RESULT_FAIL_LOSS;
                        this.pingToGoogleTest.info = Texts.PING_TEST_INFO_FAIL_LOSS;
                    } else {
                        this.pingToGoogleTest.setStatus(TestStatus.WARN);
                        this.pingToGoogleTest.result = Texts.TEST_RESULT_FAIL_PARSE;
                        this.pingToGoogleTest.info = Texts.TEST_INFO_WARN_CANT_PARSE;
                    }
                }
            } catch (e) {
                this.pingToGoogleTest.setStatus(TestStatus.WARN);
                this.pingToGoogleTest.result = Texts.TEST_RESULT_FAIL_PARSE;
                this.pingToGoogleTest.info = Texts.TEST_INFO_WARN_CANT_PARSE;
            }
        }

        private flexoTraceroute(): void {
            this.networkNodeService.getNodeTracerouteTest(this.node, this.mappingToFlexo.ipAddress).then((result: Models.ITestResult) => {
                if (!this.destroyed) {
                    this.flexoTracerouteResult = result;
                    this.traceToFlexoTest.data = result.result;
                    this.analyzeFlexoTraceroute();
                    this.runTests();
                }
            }).catch((reason: ngCustom.IReason) => {
                if (!this.destroyed) {
                    this.flexoTracerouteResult = reason.data as Models.ITestResult;

                    if (reason.data && reason.data.error) {
                        this.traceToFlexoTest.data = reason.data.error;
                        if (reason.data.error.indexOf("ConnectTimeoutException") !== -1) {
                            this.traceToFlexoTest.result = Texts.TEST_RESULT_FAIL_TIMEOUT;
                            this.traceToFlexoTest.info = Texts.TEST_INFO_FAIL_TIMEOUT;
                        } else if (reason.data.error.indexOf("HttpHostConnectException") !== -1) {
                            this.traceToFlexoTest.result = Texts.TEST_RESULT_FAIL_CONN;
                            this.traceToFlexoTest.info = Texts.TEST_INFO_FAIL_CONN;
                        } else if (reason.data.error.indexOf("NoRouteToHostException") !== -1) {
                            this.traceToFlexoTest.result = Texts.TEST_RESULT_FAIL_NOROUTE;
                            this.traceToFlexoTest.info = Texts.TEST_INFO_FAIL_NOROUTE;
                        } else if (reason.data.error.indexOf("NoHttpResponseException") !== -1) {
                            this.traceToFlexoTest.result = Texts.TEST_RESULT_FAIL_CONN;
                            this.traceToFlexoTest.info = Texts.TEST_RESULT_FAIL_CONN;
                        } else {
                            this.traceToFlexoTest.result = Texts.TEST_RESULT_FAIL_EXEC;
                            this.traceToFlexoTest.info = "";
                        }
                    } else {
                        this.traceToFlexoTest.result = Texts.TEST_RESULT_FAIL_EXEC;
                        this.traceToFlexoTest.info = "";
                    }

                    this.traceToFlexoTest.setStatus(TestStatus.FAIL);
                    this.runTests();
                }
            });
        }

        private flexoUdpPingEndToEndTest(): void {
            this.udpPingRunning = true;
            this.networkNodeService.getUdpEndToEndTest(this.node, this.targetSrt, this.targetPort).then((result: Models.ITestResult) => {
                this.udpPingRunning = false;
                if (!this.destroyed) {
                    this.udpPingResult = result;
                    this.udpPingTest.data = result.result;
                    this.analyzeUdpPingData();
                    this.runTests();
                }
            }).catch((reason: ngCustom.IReason) => {
                this.udpPingRunning = false;
                if (!this.destroyed) {
                    this.udpPingResult = reason.data as Models.ITestResult;

                    if (reason.data && reason.data.error) {
                        this.udpPingTest.data = reason.data.error;
                        if (reason.data.error.indexOf("ConnectTimeoutException") !== -1) {
                            this.udpPingTest.result = Texts.TEST_RESULT_FAIL_TIMEOUT;
                            this.udpPingTest.info = Texts.TEST_INFO_FAIL_TIMEOUT;
                        } else if (reason.data.error.indexOf("HttpHostConnectException") !== -1) {
                            this.udpPingTest.result = Texts.TEST_RESULT_FAIL_CONN;
                            this.udpPingTest.info = Texts.TEST_INFO_FAIL_CONN;
                        } else if (reason.data.error.indexOf("NoRouteToHostException") !== -1) {
                            this.udpPingTest.result = Texts.TEST_RESULT_FAIL_NOROUTE;
                            this.udpPingTest.info = Texts.TEST_INFO_FAIL_NOROUTE;
                        } else if (reason.data.error.indexOf("NoHttpResponseException") !== -1) {
                            this.udpPingTest.result = Texts.TEST_RESULT_FAIL_CONN;
                            this.udpPingTest.info = Texts.TEST_RESULT_FAIL_CONN;
                        } else {
                            this.udpPingTest.result = Texts.TEST_RESULT_FAIL_EXEC;
                            this.udpPingTest.info = "";
                        }
                    } else {
                        this.udpPingTest.result = Texts.TEST_RESULT_FAIL_EXEC;
                        this.udpPingTest.info = "";
                    }

                    this.udpPingTest.setStatus(TestStatus.FAIL);
                    this.runTests();
                }
            });
        }

        private flexoUdpListenEndToEndTest(): void {
            this.udpListenRunning = true;
            this.networkNodeService.getUdpEndToEndTestInterval(this.targetSrt, this.node, this.targetPort, 500).then((result: Models.ITestResult) => {
                this.udpListenRunning = false;
                if (!this.destroyed) {
                    this.udpListenResult = result;
                    this.udpListenTest.data = result.result;
                    this.analyzeUdpListenData();
                    this.runTests();
                }
            }).catch((reason: ngCustom.IReason) => {
                this.udpListenRunning = false;
                if (!this.destroyed) {
                    this.udpListenResult = reason.data as Models.ITestResult;

                    if (reason.data && reason.data.error) {
                        this.udpListenTest.data = reason.data.error;
                        if (reason.data.error.indexOf("ConnectTimeoutException") !== -1) {
                            this.udpListenTest.result = Texts.TEST_RESULT_FAIL_TIMEOUT;
                            this.udpListenTest.info = Texts.TEST_INFO_FAIL_TIMEOUT;
                        } else if (reason.data.error.indexOf("HttpHostConnectException") !== -1) {
                            this.udpListenTest.result = Texts.TEST_RESULT_FAIL_CONN;
                            this.udpListenTest.info = Texts.TEST_INFO_FAIL_CONN;
                        } else if (reason.data.error.indexOf("NoRouteToHostException") !== -1) {
                            this.udpListenTest.result = Texts.TEST_RESULT_FAIL_NOROUTE;
                            this.udpListenTest.info = Texts.TEST_INFO_FAIL_NOROUTE;
                        } else if (reason.data.error.indexOf("NoHttpResponseException") !== -1) {
                            this.udpListenTest.result = Texts.TEST_RESULT_FAIL_CONN;
                            this.udpListenTest.info = Texts.TEST_RESULT_FAIL_CONN;
                        } else {
                            this.udpListenTest.result = Texts.TEST_RESULT_FAIL_EXEC;
                            this.udpListenTest.info = "";
                        }
                    } else {
                        this.udpListenTest.result = Texts.TEST_RESULT_FAIL_EXEC;
                        this.udpListenTest.info = "";
                    }

                    this.udpListenTest.setStatus(TestStatus.FAIL);
                    this.runTests();
                }
            });
        }

        private analyzeFlexoTraceroute(): void {
            try {
                // this a bit ugly, but works while the traceroute result does not change
                let hops: number = this.flexoTracerouteResult.result.split('\n').length - 1;
                if (hops < 20) {
                    this.traceToFlexoTest.setStatus(TestStatus.PASS);
                    this.traceToFlexoTest.result = Texts.TRACE_TEST_RESULT_PASS.replace("%HOPS%", hops.toString());
                    this.traceToFlexoTest.info = "";
                } else {
                    if (hops < 30) {
                        this.traceToFlexoTest.setStatus(TestStatus.WARN);
                    } else {
                        this.traceToFlexoTest.setStatus(TestStatus.FAIL);
                    }
                    this.traceToFlexoTest.info = Texts.TRACE_TEST_INFO_WARNFAIL;
                    this.traceToFlexoTest.result = Texts.TRACE_TEST_RESULT_WARNFAIL.replace("%HOPS%", hops.toString());
                }
            } catch (e) {
                this.traceToFlexoTest.setStatus(TestStatus.WARN);
                this.traceToFlexoTest.result = Texts.TEST_RESULT_FAIL_PARSE;
                this.traceToFlexoTest.info = Texts.TEST_INFO_WARN_CANT_PARSE;
            }

        }

        private analyzeUdpPingData() : void {
            this.udpPingTest.setStatus(TestStatus.PASS);
            this.udpPingTest.result = Texts.UDP_PING_TEST_RESULT_PASS;
            this.udpPingTest.info = "";
        }


        private analyzeUdpListenData() : void {
            this.udpListenTest.setStatus(TestStatus.PASS);
            this.udpListenTest.result = Texts.UDP_LISTEN_TEST_RESULT_PASS;
            this.udpListenTest.info = "";
        }

        private googleTraceroute(): void {
            this.networkNodeService.getNodeTracerouteTest(this.node, this.tracerouteGoogleIp).then((result: Models.ITestResult) => {
                if (!this.destroyed) {
                    this.googleTracerouteResult = result;
                    this.traceToGoogleTest.data = result.result;
                    this.analyzeGoogleTraceroute();
                    this.runTests();
                }
            }).catch((reason: ngCustom.IReason) => {
                if (!this.destroyed) {
                    this.googleTracerouteResult = reason.data as Models.ITestResult;
                    let status: TestStatus = TestStatus.FAIL;

                    if (reason.data && reason.data.error) {
                        this.traceToGoogleTest.data = reason.data.error;
                        if (reason.data.error.indexOf("ConnectTimeoutException") !== -1) {
                            this.traceToGoogleTest.result = Texts.TEST_RESULT_FAIL_TIMEOUT;
                            this.traceToGoogleTest.info = Texts.TEST_INFO_FAIL_TIMEOUT;
                        } else if (reason.data.error.indexOf("HttpHostConnectException") !== -1) {
                            this.traceToGoogleTest.result = Texts.TEST_RESULT_FAIL_CONN;
                            this.traceToGoogleTest.info = Texts.TEST_INFO_FAIL_CONN;
                        } else if (reason.data.error.indexOf("NoRouteToHostException") !== -1) {
                            this.traceToGoogleTest.result = Texts.TEST_RESULT_FAIL_NOROUTE;
                            this.traceToGoogleTest.info = Texts.TEST_INFO_FAIL_NOROUTE;
                        } else {
                            this.traceToGoogleTest.result = Texts.TEST_RESULT_FAIL_EXEC;
                            this.traceToGoogleTest.info =  this.messageTranslationsService
                                                               .getMessageAsStringByKeySync('warning.info.fail.google.traceroute');
                            status = TestStatus.WARN;
                        }
                    } else {
                        this.traceToGoogleTest.result = Texts.TEST_RESULT_FAIL_EXEC;
                        this.traceToGoogleTest.info = "";
                    }

                    this.traceToGoogleTest.setStatus(status);
                    this.runTests();
                }
            });
        }

        private analyzeGoogleTraceroute(): void {
            try {
                // this a bit ugly, but works while the traaceroute result does not change
                let hops: number = this.googleTracerouteResult.result.split('\n').length - 1;

                if (hops < 20) {
                    this.traceToGoogleTest.setStatus(TestStatus.PASS);
                    this.traceToGoogleTest.result = Texts.TRACE_TEST_RESULT_PASS.replace("%HOPS%", hops.toString());
                    this.traceToGoogleTest.info = "";
                } else {
                    if (hops < 30) {
                        this.traceToGoogleTest.setStatus(TestStatus.WARN);
                    } else {
                        this.traceToGoogleTest.setStatus(TestStatus.FAIL);
                    }
                    this.traceToGoogleTest.info = Texts.TRACE_TEST_INFO_WARNFAIL;
                    this.traceToGoogleTest.result = Texts.TRACE_TEST_RESULT_WARNFAIL.replace("%HOPS%", hops.toString());
                }
            } catch (e) {
                this.traceToGoogleTest.setStatus(TestStatus.WARN);
                this.traceToGoogleTest.result = Texts.TEST_RESULT_FAIL_PARSE;
                this.traceToGoogleTest.info = Texts.TEST_INFO_WARN_CANT_PARSE;
            }
        }

        private clientIdConnectedInServer(clientId: number): boolean {
            /* tslint:disable */
            return (this.serverClients && this.serverClients.slots[clientId - 1] !== null);
            /* tslint:enable */
        }

        private speedTest(): void {
            this.speedTestReloading = true;
            this.networkNodeService.getNodeSpeedTest(this.node).then((result: Models.ISpeedTestResult) => {
                if (!this.destroyed) {
                    this.speedTestResult = result;
                    this.speedTestReloading = false;
                    this.initSpeedGraph(result);

                    let multiplier: number = this.serverClients.slots.length;
                    let mbps: number = this.kbpsToMpbs(result.totalAverage);
                    if (mbps > 20 * multiplier) {
                        this.bandwidthTest.setStatus(TestStatus.PASS);
                    } else  if (mbps > 18 * multiplier) {
                        this.bandwidthTest.setStatus(TestStatus.WARN);
                    } else {
                        this.bandwidthTest.setStatus(TestStatus.FAIL);
                    }
                    this.bandwidthTest.result = Texts.BW_TEST_RESULT.replace("%MBPS%", mbps.toString())
                                                                    .replace("%MULT%", multiplier.toString());

                    if (this.bandwidthTest.status === TestStatus.PASS) {
                        this.bandwidthTest.info = "";
                    } else if (this.bandwidthTest.status === TestStatus.WARN) {
                        this.bandwidthTest.info = Texts.BW_TEST_INFO_WARN;
                    } else if (this.bandwidthTest.status === TestStatus.FAIL) {
                        this.bandwidthTest.info = Texts.BW_TEST_INFO_FAIL;
                    }

                    this.runTests();
                }
            }).catch((reason: ngCustom.IReason) => {
                if (!this.destroyed) {
                    this.speedTestReloading = false;
                    this.speedTestResult = reason.data as Models.ISpeedTestResult;

                    if (reason.data && reason.data.errorMessage) {
                        this.bandwidthTest.data = reason.data.errorMessage;
                        if (reason.data.errorMessage.indexOf("ConnectTimeoutException") !== -1) {
                            this.bandwidthTest.result = Texts.TEST_RESULT_FAIL_TIMEOUT;
                            this.bandwidthTest.info = Texts.TEST_INFO_FAIL_TIMEOUT;
                        } else if (reason.data.errorMessage.indexOf("HttpHostConnectException") !== -1) {
                            this.bandwidthTest.result = Texts.TEST_RESULT_FAIL_CONN;
                            this.bandwidthTest.info = Texts.TEST_INFO_FAIL_CONN;
                        } else if (reason.data.errorMessage.indexOf("NoRouteToHostException") !== -1) {
                            this.bandwidthTest.result = Texts.TEST_RESULT_FAIL_NOROUTE;
                            this.bandwidthTest.info = Texts.TEST_INFO_FAIL_NOROUTE;
                        } else {
                            this.bandwidthTest.result = Texts.TEST_RESULT_FAIL_EXEC;
                            this.bandwidthTest.info = "";
                        }
                    } else {
                        this.bandwidthTest.result = Texts.TEST_RESULT_FAIL_EXEC;
                        this.bandwidthTest.info = "";
                    }

                    this.bandwidthTest.setStatus(TestStatus.FAIL);
                    this.runTests();
                }
            });
        }

        private initSpeedGraph(result: Models.ISpeedTestResult): void {
            this.initGraph();
            let initMilli: number = new Date().getTime();
            this.$timeout(() => {
                this.plotGraph(result, initMilli);
            }, 150);
            this.$scope.$watch('mc.timezoneService.timezoneOptions',
                (newValue: EurovisionControl.IRadioOption[], oldValue: EurovisionControl.IRadioOption[]) => {
                    if (newValue !== undefined && newValue !== oldValue) {
                        this.plotGraph(result, initMilli);
                    }
            }, true);

            this.$scope.$watch('mc.selectedTimezone',
                (newValue: Models.ITimezone, oldValue: Models.ITimezone) => {
                    if (newValue !== undefined && newValue !== oldValue) {
                        this.plotGraph(result, initMilli);
                    }
            });
        }

        private initGraph(): void {
            this.graphOptions = {
                colors: ['#22C969'],
                series: {
                    lines: {
                        show: true,
                        lineWidth: 2.0,
                        fill: true,
                    },
                    curvedLines: {
                        active: true,
                        apply: true,
                    },
                },
                grid: {
                    hoverable: true,
                    backgroundColor: "#434442",
                    color: {
                        top: "#434442",
                        right: "#434442",
                        bottom: "lightslategray",
                        left: "lightslategray",
                    },
                    markings: [],
                },
                axisLabels: {
                    show: true,
                    color: 'lightslategray',
                    axisLabelColour: 'lightslategray',
                },
                yaxes: [{
                    position: 'left',
                    axisLabel: 'Kbps',
                    axisLabelPadding: 10,
                    axisLabelFontSizePixels: 12,
                    axisLabelColour: "lightslategray",
                },
                ],
                xaxis: {
                    mode: "time",
                    // timezone: "Etc/GMT+10",
                    tickSize: [1, "second"],
                    axisLabelUseCanvas: true,
                    tickColor: "gray",
                    color: 'lightslategray',
                    axisLabelColour: 'lightslategray',
                },
                yaxis: {
                    axisLabelUseCanvas: true,
                    tickColor: "gray",
                    min: 0,
                },
                legend: false,
            };

            this.initialDateTime =  new Date().getTime();
        }

        private plotGraph(result: Models.ISpeedTestResult, initMilli: number): void {
            let dataToPlot: number[][] = new Array();
            initMilli += this.timezoneService.getEffectiveOffsetSeconds() * 1000;
            result.totalSamples.forEach((sample: number, index: number) => {
                 let timestamp: number = initMilli + (index * 100);
                 dataToPlot.push([timestamp, sample]);
            });
            let series: Object[] = [{ data: dataToPlot, points: { show: false}}];
            result.hostResults.forEach((hostResult: Models.ISpeedTestHostResult, hostIndex: number) =>  {
                let hostDataToPlot: number[][] = new Array();
                hostResult.bandwithSamples.forEach((sample: number, index: number) => {
                    let timestamp: number = initMilli + (index * 100);
                    hostDataToPlot.push([timestamp, sample]);
                });
                series.push({data: hostDataToPlot,
                    points: {show: false},
                    lines: {
                        show: true,
                        fill: false,
                        opacity: 1,
                    },
                    color: this.serieColors[hostIndex],
                });
            });
            let yMax: number = 1;
            dataToPlot.forEach((data: number[]) => {
                if (yMax < data[1]) yMax = data[1];
            });
            this.graphOptions.yaxis.max = Math.ceil(yMax);
            this.graph = $.plot($('#speed-test-graph'), series, this.graphOptions);
            let previousPoint: number[] = [];
            let speedGraph: JQuery.IJQueryFlotBind = $('#speed-test-graph');
            speedGraph.bind("plothover", (event: JQueryEventObject, pos: jquery.flot.pos, item: jquery.flot.item) => {
                if (item) {
                    if (previousPoint !== item.datapoint) {
                        previousPoint = item.datapoint;
                        $("#tooltip").hide();
                        $("#tooltip")
                            .css({
                                top: item.pageY - 35,
                                left: item.pageX - 60,
                            })
                            .html(item.datapoint[1].toFixed(2) + ' kbit/secs')
                            .show();
                    }
                } else {
                    $("#tooltip").hide();
                    previousPoint = undefined;
                }
            });
        }

        private checkInUse(): ng.IPromise<boolean> {
            let streamPipeStatus: boolean = false;
            let strIdFromHref: String = (Common.Utils.strIdFromHref(this.node.href));
            return this.blockConnectionNodesService.getBlockConnectionNodes(strIdFromHref)
                .then((streamPipe: Services.IBlockConnection[]) => {
                    streamPipe.forEach((value: Services.IBlockConnection) => {
                        if (value.streamPipeStatus) {
                            streamPipeStatus =  true;
                        }
                    });
                    return streamPipeStatus;
                });

        }
    }

    class Test {
        // private static TEST_ELEMENTS: string = "#tests-parent h3.uk-accordion-title";

        private static WAITING_LABEL: string = "WAITING";
        private static IN_PROCESS_LABEL: string = "IN PROCESS";
        private static NO_TEST_LABEL: string = "NO TEST";
        private static DEVICE_IN_USE_LABEL: string = "IN USE";
        private static PASS_LABEL: string = "PASS";
        private static WARN_LABEL: string = "WARN";
        private static FAIL_LABEL: string = "FAIL";


        private static WAITING_BADGE_CLASS: string = "md-bg-deep-purple-400";
        private static IN_PROCESS_BADGE_CLASS_ON: string = "md-bg-blue-600 md-color-blue-50";
        private static IN_PROCESS_BADGE_CLASS_OFF: string = "md-bg-blue-50 md-color-blue-600";
        private static NO_TEST_BADGE_CLASS: string = "md-bg-grey-400";
        private static DEVICE_IN_USE_CLASS: string = "md-bg-grey-400";
        private static PASS_BADGE_CLASS: string = "uk-badge-success";
        private static WARN_BADGE_CLASS: string = "uk-badge-warning";
        private static FAIL_BADGE_CLASS: string = "uk-badge-danger";


        private static WAITING_BG_CLASS: string = "md-bg-purple-50";
        private static IN_PROCESS_BG_CLASS: string = "md-bg-blue-50";
        private static NO_TEST_BG_CLASS: string = "";
        private static DEVICE_IN_USE_BG_CLASS: string = "";
        private static PASS_BG_CLASS: string = "md-bg-light-green-100";
        private static WARN_BG_CLASS: string = "md-bg-orange-50";
        private static FAIL_BG_CLASS: string = "md-bg-red-50";

        public index: number;
        public title: string;
        public status: TestStatus;
        public badgeClass: string;
        public badgeLabel: string;
        public bgClass: string;
        public result: string;
        public info: string;
        public data: string | Object;
        public run: () => void;
        public displayed: boolean;

        private $timeout: ng.ITimeoutService;

        constructor($timeout: ng.ITimeoutService, index: number, title: string) {
            this.$timeout = $timeout;
            this.index = index;
            this.title = title;
            this.status = TestStatus.WAITING;
            this.badgeClass = Test.WAITING_BADGE_CLASS;
            this.badgeLabel = Test.WAITING_LABEL;
            this.bgClass = Test.WAITING_BG_CLASS;
            this.result = "...";
            this.info = Texts.PENDING;
            this.data = '';
            this.displayed = false;
        }

        public setStatus(status: TestStatus): void {
            if (status === TestStatus.WARN || status === TestStatus.FAIL) {
                if (!this.displayed) {
                    // displays the accordion
                    this.displayed = true;
                    /* disabled for now!
                    this.$timeout(() => {
                        $(Test.TEST_ELEMENTS)[this.index].click();
                    });
                    */
                }
            }

            this.status = status;
            this.update();
        }

        public blink(): void {
            if (this.status === TestStatus.IN_PROCESS) {
                if (this.badgeClass === Test.IN_PROCESS_BADGE_CLASS_ON) {
                    this.badgeClass = Test.IN_PROCESS_BADGE_CLASS_OFF;
                } else {
                    this.badgeClass = Test.IN_PROCESS_BADGE_CLASS_ON;
                }
            }
        }

        public toggleDisplayed(): void {
            this.displayed = !this.displayed;
        }

        private update(): void {
            switch (this.status) {
                case TestStatus.IN_PROCESS:
                    this.badgeClass = Test.IN_PROCESS_BADGE_CLASS_ON;
                    this.badgeLabel = Test.IN_PROCESS_LABEL;
                    this.bgClass = Test.IN_PROCESS_BG_CLASS;
                    break;
                case TestStatus.PASS:
                    this.badgeClass = Test.PASS_BADGE_CLASS;
                    this.badgeLabel = Test.PASS_LABEL;
                    this.bgClass = Test.PASS_BG_CLASS;
                    break;
                case TestStatus.WARN:
                    this.badgeClass = Test.WARN_BADGE_CLASS;
                    this.badgeLabel = Test.WARN_LABEL;
                    this.bgClass = Test.WARN_BG_CLASS;
                    break;
                case TestStatus.FAIL:
                    this.badgeClass = Test.FAIL_BADGE_CLASS;
                    this.badgeLabel = Test.FAIL_LABEL;
                    this.bgClass = Test.FAIL_BG_CLASS;
                    break;
                case TestStatus.NO_TEST:
                    this.result = "No test";
                    this.info = "";
                    this.badgeClass = Test.NO_TEST_BADGE_CLASS;
                    this.badgeLabel = Test.NO_TEST_LABEL;
                    this.bgClass = Test.NO_TEST_BG_CLASS;
                    break;
                case TestStatus.DEVICE_IN_USE:
                    this.result = "This device is being used, shouldn't run a speedtest on it ";
                    this.info = "";
                    this.badgeClass = Test.DEVICE_IN_USE_CLASS;
                    this.badgeLabel = Test.DEVICE_IN_USE_LABEL;
                    this.bgClass = Test.DEVICE_IN_USE_BG_CLASS;
                    break;
                default:
                    break;
            }
        }
    }

    enum TestStatus {
        WAITING,
        IN_PROCESS,
        NO_TEST,
        PASS,
        WARN,
        FAIL,
        DEVICE_IN_USE
    }
}
